import React, { memo } from 'react';
import styles from './button.module.scss';

export const Button = memo(({ title, click }) => {
  return (
    <div className={styles.button_wrap}>
     <button  className={styles.button} onClick={click}>{title}</button>
    </div>
  );
});
